<form #filterForm="ngForm">
    <div class="row">
        <div class="col-md-12 col-lg form-field">
            <input name="filterStudent"
                   class="form-control"
                   [placeholder]="'bcContestStudent_lblFullName' | translate"
                   [(ngModel)]="filters.student"
                   (input)="filter()">
        </div>

        <div class="col-md-6 col-lg form-field">
            <app-select name="filterProgram"
                        [placeholder]="'bcContestStudent_lblProgram' | translate"
                        [options]="filters.program.options"
                        [multiple]="true"
                        [filter]="true"
                        [(ngModel)]="filters.program.value"
                        (selectionChange)="filter()">
            </app-select>
        </div>

        <div class="col-md-6 col-lg form-field">
            <app-select name="filterCreditPoints"
                        [placeholder]="'bcContestStudent_lblCreditPoints' | translate"
                        [options]="filters.creditPoints.options"
                        [multiple]="true"
                        [(ngModel)]="filters.creditPoints.value"
                        (selectionChange)="filter()">
            </app-select>
        </div>
    </div>

    <div class="row">
        <div class="col-md form-field">
            <label class="form-label">{{'bcContestStudent_lblApplicationCount' | translate}}</label>
            <div class="input-group">
                <input name="filterCountFrom"
                       class="form-control"
                       [placeholder]="'bcContestStudent_lblFrom' | translate"
                       [(ngModel)]="filters.countFrom"
                       (input)="filter()">

                <input name="filterCountTo"
                       class="form-control"
                       [placeholder]="'bcContestStudent_lblTo' | translate"
                       [(ngModel)]="filters.countTo"
                       (input)="filter()">
            </div>
        </div>

        <div class="col-md form-field">
            <label class="form-label">{{'bcContestStudent_lblGrade' | translate}}</label>
            <div class="input-group">
                <input name="filterGradeFrom"
                       class="form-control"
                       [placeholder]="'bcContestStudent_lblFrom' | translate"
                       [(ngModel)]="filters.gradeFrom"
                       (input)="filter()">

                <input name="filterCountTo"
                       class="form-control"
                       [placeholder]="'bcContestStudent_lblTo' | translate"
                       [(ngModel)]="filters.gradeTo"
                       (input)="filter()">
            </div>
        </div>

        <div class="col-md form-field">
            <label class="form-label">{{'bcContestStudent_lblCustomGrade' | translate}}</label>
            <div class="input-group">
                <input name="filterCustomGradeFrom"
                       class="form-control"
                       [placeholder]="'bcContestStudent_lblFrom' | translate"
                       [(ngModel)]="filters.customGradeFrom"
                       (input)="filter()">

                <input name="filterCustomGradeTo"
                       class="form-control"
                       [placeholder]="'bcContestStudent_lblTo' | translate"
                       [(ngModel)]="filters.customGradeTo"
                       (input)="filter()">
            </div>
        </div>
    </div>
</form>

<app-table [rows]="items"
           [columns]="columns"
           [page]="page"
           [pageSize]="pageSize"
           [total]="total"
           [auto]="autoPage"
           sticky="right"
           (pageChange)="onPage($event)"
           (sortChange)="onSort($event)">
    <ng-template #rowTemplate let-row>
        <tr>
            <td>
                <div>{{row.FullName}}</div>
                <div class="text-sub">{{row.Upn}}</div>
            </td>
            <td>{{row.Program}}</td>
            <td>{{row.CreditPoints}}</td>
            <td>{{row.ApplicationCount}}</td>
            <td>{{row.Grade}}</td>
            <td>{{row.CustomGrade}}</td>
            <td>
                <div class="table-actions">
                    <button type="button" class="btn btn-outline btn-icon" [ngbTooltip]="'edit' | translate"
                            (click)="edit(row)" *ngIf="!isReadOnly && canEdit">
                        <i class="fi fi-rs-pencil"></i>
                    </button>

                    <a *ngIf="isOpened"
                       class="btn btn-outline btn-icon"
                       [ngbTooltip]="'bcContestStudent_btnApply' | translate"
                       [routerLink]="['/bc-contests/apply'] | localize"
                       [queryParams]="{ upn: row.Upn }"
                       target="_blank">
                        <i class="fi fi-rs-apps-add"></i>
                    </a>

                    <button type="button" class="btn btn-outline btn-icon" [ngbTooltip]="'bcContestStudent_btnApplications' | translate"
                            (click)="openApplications(row)">
                        <i class="fi fi-rs-apps"></i>
                    </button>
                </div>
            </td>
        </tr>
    </ng-template>
</app-table>
